import axios from "../../axios-config"

// create mix enhancer preview
export const createMixEnhancerPreview = async (body) => {
  const res = await axios.post(
    "/audio-engineer/v1/create-mix-enhance-preview",
    body
  );
  return res.data;
};

// create full mix enhanced
export const createFullMixEnhanced = async (body) => {
  const res = await axios.post(
    "/audio-engineer/v1/create-full-mix-enhance",
    body
  );
  return res.data;
};

// retrieve full mix enhanced track
export const retrieveEnhancedTrack = async (body) => {
  const res = await axios.post(
    "/audio-engineer/v1/retrieve-enhanced-track",
    body
  );
  return res.data;
};

// retrieve stems of a track
export const retrieveTrackStems = async (id) => {
  const res = await axios.get(
    `/audio-engineer/v1/stems-splits-library/${id}/stems`
  );
  return res.data;
};

//delete a stem of mixed track
export const deleteTrackStem = async ({ id }) => {
  let url = `/audio-engineer/v1/stems-splits-library`;
  
  // Check if id is an array (multiple IDs)
  if (Array.isArray(id)) {
    const stemIds = id.join(',');
    url += `?stemIds=${stemIds}`;
  } else {
    // Single ID deletion
    url += `/${id}`;
  }
  
  const res = await axios.delete(url);
  return res.data;
};

//rename a stem of mixed track
export const renameTrackStem = async (id, body) => {
  const res = await axios.patch(
    `/audio-engineer/v1/stems-splits-library/${id}/rename`, body
  );
  return res.data;
};

//search stems library
export const searchStemsLibrary = async ({id, q}) => {
  const res = await axios.get(
    `/audio-engineer/v1/stems-splits-library/search?id=${id}&q=${q}`
  );

  return res.data?.data || [];
};